import UploadImage from '@/components/upload-image/index.vue';
import { mapGetters } from 'vuex';
import TransactionProService from '../../project.service.js';
import Service from '@/service/index.js';
import SelectBank from '@/components/select-bank/index.vue';
import { errorMessage, successMessage } from '@/utils/message.js';

export default {
  components: {
    UploadImage,
    SelectBank
  },
  data() {
    return {
      projectId: '',
      ruleForm: {
        remark: '',
        files: [],
        assetsBidInfos: [],
        purpose: '',
        bankId: ''
      },
      otherPurposeCheck: false, // 用途是其他的时候展示
      projectTypeList: [],
      identityList: [],
      projectInfo: [],
      bidId: '',
      contractorPriority: [], // 优先权人返回集合
      rules: {
        purpose: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        bankId: [
          { required: true, message: '请选择银行账号', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters([
      'loginUserType',
      'assetsBidInfos',
      'userInfo'
    ])
  },
  created () {
    this.id = this.$route.query.projectId;
    this.ruleForm.assetsBidInfos.push({projectBidId: this.$route.query.bidId});
    if (this.id) {
      this.getTransProjectDetail();
    }
    // 受让用途
    Service.getSelectList('TRANSFEREE_PURPOSE').then(res => {
      if (res && res.code === '0') {
        this.projectTypeList = res.data;
      }
    });

    // 上传图片 获取文件
    Service.getSelectList('SIGN_PEOPLE_BID_FILE_TYPE').then(res => {
      if (res && res.code === '0') {
        const arr = [];
        // 受让资格材料证明
        res.data.forEach(item => {
          let userType = Number(this.userInfo.type);
          // 单位用户
          if(userType === 2) { // 法人的授权委托书
            if(item.code === '1'){
              item.code = 14;
              arr[0] = item;
              arr[0]['value'] = '法人单位的授权委托书';
              // // TODO 机动地
              // if(this.projectInfo && this.projectInfo.projectType === 1 && this.projectInfo.projectSubType === 1) {
              //   arr[0]['value'] = '法人单位的授权委托书';
              // }
            }
            if(item.code === '3'){ // 其他材料
              item.code = 11;
              arr[1] = item;
            }
          } else {
            if(item.code === '3'){
              item.code = 11;
              arr[0] = item;
            }
          }
          return arr;
        });
        // console.log(arr);
        this.initFile(arr);
      }
    });
  },
  methods: {
    // 文件接口 转化
    initFile (arr) {
      arr.forEach(item => {
        this.ruleForm.files.push({
          projectFileType: Number(item.code),
          title: item.value,
          filePaths: [],
          inputValue: null
        });
      });
    },
    // 跳转授权委托书样例
    downTemplate() {
      window.open('/授权委托书样例（法人机构用户）.pdf');
    },
    // 对图片做必填校验的判断
    fileRules (item) {
      let required = true;
      if (item.projectFileType === 11) {
        required = false;
      }
      return {
        required: required,
        message: '请上传' + item.title,
        trigger: 'change'
      };
    },
    // 获取交易详情
    getTransProjectDetail() {
      TransactionProService.getRollOutProjectDetail({
        projectId: this.id,
        echoCode: 'PROJECT'
      }).then(res => {
        if (res && res.code === '0') {
          this.projectInfo = res.data;
        }
      });
    },
    // 上传图片
    uploadImage (index, event) {
      this.ruleForm.files[index].filePaths = event;
      if (event.length) {
        this.ruleForm.files[index].inputValue = event.length;
      } else {
        this.ruleForm.files[index].inputValue = null;
      }
    },
    // 选择受让用途的时候
    selectChanged(row) {
      if(row.code === '8') {
        this.otherPurposeCheck = true;
      } else {
        this.otherPurposeCheck = false;
      }
    },
    // 返回
    previousStep () {
      this.$router.back();
    },
    // 立即提交
    test() {
      this.$refs['signUpForm'].validate((valid) => {
        if (valid) {
          this.$confirm('是否继续提交上传材料信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit();
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
    },
    // 确认提交按钮
    submit() {
      const files = [];
      // 文件传参
      this.ruleForm.files.forEach(item => {
        const filePaths = [];
        item.filePaths.forEach(obj => {
          filePaths.push(obj.sourceImgUrl);
        });
        files.push({
          imgEnumType: item.projectFileType,
          urls: [...filePaths]
        });
      });
      // 标的信息 =》标的id和受用信息
      this.ruleForm.assetsBidInfos.forEach(item => {
        item.purpose = this.ruleForm.purpose;
        // if(this.otherPurposeCheck === true) {
        //   item.purpose = this.purpose;
        // } else {
        //   item.purpose = this.ruleForm.purpose;
        // }
      });
      // 保存接口传参
      TransactionProService.atonceSign({
        ...this.ruleForm,
        files: files,
        projectId: this.id
      }).then(res => {
        if (res && res.code === '0') {
          successMessage('上传材料成功');
          this.$router.push('/person-center/project/contracted-project/list');
        } else if (res && res.reason) {
          errorMessage(res && res.reason);
        } else {
          errorMessage('上传材料失败');
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        } else {
          errorMessage('上传材料失败');
        }
      });
    }
  }
};
